import React from "react";
import "./card-generic.css";

const CardGeneric = ({
	title,
	subtitle,
	headerAction,
	children,
	className = "",
	bodyClassName = "",
	compact = false
}) => {
	return (
		<section
			className={[
				"card-generic",
				compact ? "card-generic--compact" : "",
				className
			].filter(Boolean).join(" ")}
		>
			{(title || subtitle || headerAction) && (
				<header className="card-generic__header">
					<div className="card-generic__heading">
						{title && (
							<h2 className="card-generic__title">
								{title}
							</h2>
						)}

						{subtitle && (
							<p className="card-generic__subtitle">
								{subtitle}
							</p>
						)}
					</div>

					{headerAction && (
						<div className="card-generic__action">
							{headerAction}
						</div>
					)}
				</header>
			)}

			<div
				className={[
					"card-generic__body",
					bodyClassName
				].filter(Boolean).join(" ")}
			>
				{children}
			</div>
		</section>
	);
};

export default CardGeneric;